/* eslint-disable camelcase */
/* eslint-disable max-len */
import { maxLength, regex, required } from '@vfde-brix/ws10/validation';
import { TrackingAvcStep } from './enums/tracking';
import { isEmailValid } from './components/formElement';

export const STORAGE_KEY = 'VF-ZP';

export const FF_ERROR_PAGE = 'https://eweb8.vfd2-testnet.de/tellyourfriend/familyandfriends_info.html';

export const SUFFIX_BANDWIDTH = 'Mbit/s';
export const BANDWIDTH_MULTIPLIER = 1000;
export const PLACEHOLDER_KEY_REGEX = /\$([a-zA-Z]+)/g; // Format: $anyText

// TODO: remove fallback const after CMS validator
export const PRE_FIBER_BID = '2534';

export const NAME_OVERLAY = 'overlay';
export const NOTIFICATION_TYPE_SUCCESS = 'success';
export const NOTIFICATION_TYPE_WARN = 'warn';
export const NOTIFICATION_TYPE_INFO = 'info';

// ===
// VALIDATOR CONFIGS: start
// ===
export const INPUT_MAX_LENGTH = 50;
export const HOUSENUMBER_MAX_LENGTH = 10;
export const INVALID_CHARS_REGEX = /\?|=|\(|\)|"|§|\$|\/|%/g;

export const REQUIRED_VALIDATION_CONFIG = { validator: required, errorKey: 'required' };
// TODO: check if the secureValue validator is enough
// export const SECURE_VALUE_VALIDATION_CONFIG = { validator: secureValue, errorKey: 'invalidCharacters' };
export const SECURE_VALUE_VALIDATION_CONFIG = {
    validator: regex,
    errorKey: 'invalidCharacters',
    regex: INVALID_CHARS_REGEX,
};
export const EMAIL_VALIDATION_CONFIG = {
    validator: isEmailValid,
    errorKey: 'email',
};

// Tracking constants
export const TRACKING_PLATFORM_TYPE_MOBILE = 'mobile';
export const TRACKING_BUSINESS_TRANSACTION_TYPE = 'fiber>internet & phone';
export const TRACKING_PRODUCT_LINE_P2 = '2P - Internet & Phone';
export const TRACKING_FLOW_TYPE = 'internet_telefon_flow';
export const TRACKING_SITE_AREA = 'fiber';
export const TRACKING_ERROR_ACTION = 'displayed';
export const TRACKING_CAPTCHA_SHOWN = 'availability-captcha-shown';

export const TRACKING_PAGE_LEVEL_AVC = 'availability check';
export const TRACKING_PAGE_TYPE = 'availability';
export const TRACKING_FORM_TYPE = 'availability';
export const TRACKING_FORM_NAME = 'product availability check';
export const TRACKING_TRANSFER_POINT_AVAILABLE = false;

export const TRACKING_TYPE_CONTACT = 'contact';
export const TRACKING_CONTACT_ACTION_ENGAGE = 'engage';
export const TRACKING_CONTACT_SUBJECT_FIBER = 'glassfiber interest';
export const TRACKING_CONTACT_TOOL = 'lead management';
export const TRACKING_CONTACT_TRIGGER_BUTTON = 'button';
export const TRACKING_CONTACT_TRIGGER_AUTO = 'automatically';

export const TRACKING_INFORMATION_UI_TYPE_TOOLTIP = 'tool tip';
export const TRACKING_INFORMATION_UI_TYPE_FOOTNOTE = 'footnote';
export const TRACKING_INFORMATION_TRIGGER_ICON = 'icon';
export const TRACKING_INFORMATION_TRIGGER_REFERENCE = 'reference footnote';
export const VODAFONE_DEVICE_NAME = 'FRITZ!Box 7590 AX oder 7530 AX';
export const TELEKOM_DEVICE_NAME = 'FRITZ!Box 5530 oder FRITZ!Box 5590';

export const TRACKING_AVC_STEP = {
    [TrackingAvcStep.SHOW]: {
        form_step: 1,
        form_step_name: 'show',
        form_status: ['start'],
    },
    [TrackingAvcStep.START]: {
        form_step: 2,
        form_step_name: 'start',
    },
    [TrackingAvcStep.COMPLETE]: {
        form_step: 3,
        form_step_name: 'complete',
        form_status: ['end', 'success'],
    },
};

export const MOBILE_REGEX = /Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone/i;
export const EMAIL_REGEX = /^.+@[^\.].*\.[a-z]{2,}$/g;

export const MAX_LENGTH_50_VALIDATION_CONFIG = {
    validator: maxLength,
    errorKey: 'maxLength50',
    maxLength: INPUT_MAX_LENGTH,
};
export const MAX_LENGTH_HOUSE_NUMBER_VALIDATION_CONFIG = {
    validator: maxLength,
    errorKey: 'maxLengthHouseNr',
    maxLength: HOUSENUMBER_MAX_LENGTH,
};
// ===
// VALIDATOR CONFIGS: end
// ===

export const FOOTNOTE_SELECTOR = 'sup';

/**
 * Fiber access supplier
 */
export const DGW = 'DGW';
export const DTAG = 'DTAG';
export const OXGG = 'OXGG';
/**
 * selected id
 */
export const SELECTEDID = 'FIB-BSA-IP-1000';
export const SELECTEDID_500 = 'FIB-BSA-IP-500';

export const WS10_HIDDEN = 'ws10-is-hidden';
export const ADDRESS_WRAPPER_TOP_MARGIN = 'fiber-address-top-margin';
